import { GIFCON_APP_API } from '@/shared/config/api';

interface ApiResponse<T> {
  data: T;
}

interface ApiErrorBody {
  code: string;
  message: string;
}

export class ApiError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(code: string, message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
  }
}

const USER_FACING_CODES = new Set(['ShortUrlNotFound', 'InvalidCouponToken', 'CouponNotFound', 'AmbiguousCoupon']);

export function isUserFacing(error: ApiError): boolean {
  return USER_FACING_CODES.has(error.code);
}

export interface RequestOptions {
  method?: string;
  body?: unknown;
}

export async function request<T>(path: string, options: RequestOptions = {}): Promise<T> {
  const { method = 'GET', body } = options;
  const res = await fetch(`${GIFCON_APP_API}${path}`, {
    method,
    credentials: 'omit',
    headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  const parsed = (await res.json().catch(() => null)) as (Partial<ApiResponse<T>> & Partial<ApiErrorBody>) | null;

  if (!res.ok) {
    throw new ApiError(parsed?.code ?? 'UNKNOWN', parsed?.message ?? '요청을 처리하지 못했습니다.', res.status);
  }
  if (!parsed || parsed.data === undefined) {
    throw new ApiError('INVALID_RESPONSE', '응답을 해석하지 못했습니다.', res.status);
  }
  return parsed.data;
}
